import React, { useEffect, useContext, useState } from "react";
import { GlobalContext } from "../../../contexts/GlobalContext";
import {
    fetchedBrands,
    fetchedUnits,
} from "../../../apis/apis.logistics/apisProduct";
import { ProductBrandList } from "../fragments.logistics/ProductBrandList";
import { ProductBrandForm } from "../fragments.logistics/ProductBrandForm";
import { UnitList } from "../fragments.logistics/UnitList";
import { UnitForm } from "../fragments.logistics/UnitForm";

function Panel({ icon, title, subtitle, headerClass, children }) {
    return (
        <div className="flex h-full flex-col overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm dark:border-gray-700 dark:bg-gray-800">
            <div className={`px-4 py-3 text-white ${headerClass}`}>
                <h2 className="flex items-center gap-2 text-lg font-semibold">
                    <i className={icon} aria-hidden="true" />
                    {title}
                </h2>
                <p className="mt-1 text-sm text-white/80">{subtitle}</p>
            </div>
            <div className="flex-1 p-4">{children}</div>
        </div>
    );
}

export function ProductBrandPage() {
    const { setBrands, setItemProductBrand } = useContext(GlobalContext);
    const [units, setUnits] = useState([]);
    const [selectedUnit, setSelectedUnit] = useState({});
    const [isBrandModalOpen, setIsBrandModalOpen] = useState(false);
    const [isUnitModalOpen, setIsUnitModalOpen] = useState(false);

    const openBrandModal = (brand) => {
        setItemProductBrand(brand);
        setIsBrandModalOpen(true);
    };

    const closeBrandModal = () => {
        setIsBrandModalOpen(false);
    };

    const openUnitModal = (unit) => {
        setSelectedUnit(unit);
        setIsUnitModalOpen(true);
    };

    const closeUnitModal = () => {
        setIsUnitModalOpen(false);
    };

    const getBrands = async () => {
        try {
            const response = await fetchedBrands();
            setBrands(response);
            return response;
        } catch (error) {
            throw error;
        }
    };

    const getUnits = async () => {
        try {
            const response = await fetchedUnits();
            setUnits(response);
            return response;
        } catch (error) {
            throw error;
        }
    };

    useEffect(() => {
        getBrands();
        getUnits();
    }, []);

    return (
        <>
            <section className="mb-6">
                <div className="max-w-full px-4">
                    <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-center">
                        <div>
                            <h1 className="flex items-center gap-2 text-2xl font-bold text-gray-900 dark:text-white">
                                <i
                                    className="fas fa-boxes text-blue-600 dark:text-blue-400"
                                    aria-hidden="true"
                                />
                                Módulo Logístico
                            </h1>
                            <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
                                Gestión de marcas y unidades de medida
                            </p>
                        </div>
                        <ol className="flex items-center gap-2 text-sm">
                            <li className="text-blue-600 dark:text-blue-400">
                                <a href="#" className="hover:underline">
                                    <i className="fas fa-home mr-1" aria-hidden="true" />
                                    Logística
                                </a>
                            </li>
                            <li className="text-gray-500 dark:text-gray-400">/</li>
                            <li className="font-medium text-gray-700 dark:text-gray-300">
                                <i className="fas fa-tags mr-1" aria-hidden="true" />
                                Marcas y Unidades
                            </li>
                        </ol>
                    </div>
                </div>
            </section>

            <section>
                <div className="max-w-full px-4">
                    <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
                        <Panel
                            icon="fas fa-trademark"
                            title="Marcas de Productos"
                            subtitle="Administre las marcas disponibles"
                            headerClass="bg-blue-600"
                        >
                            <ProductBrandList onOpenBrandModal={openBrandModal} />
                        </Panel>

                        <Panel
                            icon="fas fa-balance-scale"
                            title="Unidades de Medida"
                            subtitle="Administre las unidades disponibles"
                            headerClass="bg-cyan-600"
                        >
                            <UnitList
                                units={units}
                                onOpenUnitModal={openUnitModal}
                            />
                        </Panel>
                    </div>

                    <ProductBrandForm
                        isOpen={isBrandModalOpen}
                        onClose={closeBrandModal}
                    />
                    <UnitForm
                        isOpen={isUnitModalOpen}
                        onClose={closeUnitModal}
                        units={units}
                        selectedUnit={selectedUnit}
                        setUnits={setUnits}
                    />
                </div>
            </section>
        </>
    );
}
